import React, { Suspense, lazy } from 'react';
import AOS from 'aos';

import './index.scss';
import { REACT_APP_IMAGES_PUBLIC_URL } from '../../config';
import { ReactComponent as LoaderIcon } from '../../img/svg/Common/Loader.svg';

const Banner = lazy(() => import('./Banner'));
const AsSeenOn = lazy(() => import('./AsSeenOn'));
const ChallengesSection = lazy(() => import('./ChallengesSection'));
const RwaBucksSection = lazy(() => import('./RwaBucksSection'));
const RwaBenefitsSection = lazy(() => import('./RwaBenefitsSection'));
const RwaUserJourneySection = lazy(() => import('./RwaUserJourneySection'));
const CreatorBenefitsSection = lazy(() => import('./CreatorBenefitsSection'));
const PromotionalFundingTwistSection = lazy(() => import('./PromotionalFundingTwistSection'));
const ParallaxComponent = lazy(() => import('../Common/ParallaxComponent'));
const BeforeStarStake = lazy(() => import('./BeforeStarStake'));
const StarStakeIs = lazy(() => import('./StarStakeIs'));
const JourneyToUniverse = lazy(() => import('../Common/JourneyToUniverse'));
const HowWorks = lazy(() => import('./HowWorks'));
const CreateBrand = lazy(() => import('./CreateBrand'));
const JoinClub = lazy(() => import('./JoinClub'));
const Testimonial = lazy(() => import('./Testimonial'));

function LandingPage() {
  React.useEffect(() => {
    AOS.refresh();
  }, []);

  return (
    <div className="landing-page-wrapper">
      <Suspense
        fallback={
          <div className="page-loader">
            <LoaderIcon />
          </div>
        }
      >
        <Banner />
        <ChallengesSection />
        <RwaBucksSection />
        <RwaBenefitsSection />
        <RwaUserJourneySection />
        <CreatorBenefitsSection />
        <PromotionalFundingTwistSection />
        {/* <AsSeenOn />
        <BeforeStarStake />
        <ParallaxComponent ParallaxData={ParallaxData} />
        <StarStakeIs />
        <JourneyToUniverse journeyData={journeyData} />
        <HowWorks />
        <Testimonial />
        <CreateBrand />*/}
        <JoinClub /> 
      </Suspense>
    </div>
  );
}

export default LandingPage;

const ParallaxData = [
  {
    heading: (
      <h2 className="text-white ">
        Real World Funding<span className="text-blue"> is the party</span> that all
        creators, stars, brands, and their backers are attending, together!
      </h2>
    ),
    subtitle:
      'Experience a new paradigm where everyone is a star, everyone wins, and everything is connected in collaboration instead of competition.',
    mainImg: `${REACT_APP_IMAGES_PUBLIC_URL}/LandingImages/parallax/Parallax1.webp`
  },
  {
    heading: (
      <h2 className="text-white ">
        Brands Deserve Support. Backers
        <span className="text-blue"> Deserve Rewards.</span>
      </h2>
    ),
    subtitle:
      'Real World Funding powers deeper connections between brands and backers that never existed before. Discover new ways to earn and grow as you rise to stardom and fandom.',
    mainImg: `${REACT_APP_IMAGES_PUBLIC_URL}/LandingImages/parallax/Parallax2.webp`
  },
  {
    heading: (
      <h2 className="text-white ">
        Real World Funding Is
        <span className="text-blue"> The Backer And Brand Ecosystem</span> You
        Didn’t Know You Could Have.
      </h2>
    ),
    subtitle:
      'Our powerful creation suite delivers Web3 features that your community will care about and use. Make your  Campaign Clubs special with perks and products, incentivize growth with promotions, build beautiful pages, and create SuperBackers with the BrandEngine.',
    mainImg: `${REACT_APP_IMAGES_PUBLIC_URL}/LandingImages/parallax/Parallax3.webp`
  },
  {
    heading: (
      <h2 className="text-white ">
        Followers into <span className="text-blue"> SuperBackers</span>. Brands
        into <span className="text-blue"> SuperBrands</span>.
      </h2>
    ),
    subtitle:
      'The old economy was not built to support creators like you. Real World Funding is designed to empower ‘brands as a business’ while giving backers greater opportunities to participate in the process. What will your new creator economy look like? Show us.',
    mainImg: `${REACT_APP_IMAGES_PUBLIC_URL}/LandingImages/parallax/Parallax4.webp`
  }
];

const journeyData = [
  {
    id: 1,
    title: <h2 className="title">Reach For The Brands</h2>,
    subtitle: (
      <p className="blue-grey-text">
        <span className="fan-span"> Browse/</span>
        <span className="creator-span">Become</span> brands and backers on
        Real World Funding
      </p>
    ),
    imgSrc: `${REACT_APP_IMAGES_PUBLIC_URL}/LandingImages/Journey/Journey1.webp`
  },
  {
    id: 2,
    title: <h2 className="title">Get Officially Connected</h2>,
    subtitle: (
      <p className="blue-grey-text">
        <span className="fan-span"> Collect/</span>
        <span className="creator-span">Create</span> free BrandConnect
      </p>
    ),
    imgSrc: `${REACT_APP_IMAGES_PUBLIC_URL}/LandingImages/Journey/Journey2.webp`
  },
  {
    id: 3,
    title: <h2 className="title">Get Cashed Up</h2>,
    subtitle: (
      <p className="blue-grey-text">
        <span className="fan-span"> Grab/</span>
        <span className="creator-span">Create</span> branded collectible NFT
        Bucks that work like cash for purchases on Real World Funding.
      </p>
    ),
    imgSrc: `${REACT_APP_IMAGES_PUBLIC_URL}/LandingImages/Journey/Journey3.webp`
  },
  {
    id: 4,
    title: <h2 className="title">Land In MarketHub</h2>,
    subtitle: (
      <p className="blue-grey-text">
        Visit MarketHub and
        <span className="fan-span"> explore/</span>
        <span className="creator-span">feature</span> offers and exclusives.
      </p>
    ),
    imgSrc: `${REACT_APP_IMAGES_PUBLIC_URL}/LandingImages/Journey/Journey4.webp`
  },
  {
    id: 5,
    title: (
      <h2 className="title">
        <span className="fan-span">Join/</span>
        <span className="creator-span">Create</span> Your Favorite Campaign Club
      </h2>
    ),
    subtitle: (
      <p className="blue-grey-text">
        <span className="fan-span">Choose/</span>
        <span className="creator-span">Create</span> access levels with perks
        and privileges.
      </p>
    ),
    imgSrc: `${REACT_APP_IMAGES_PUBLIC_URL}/LandingImages/Journey/Journey5.webp`
  },
  {
    id: 6,
    title: (
      <h2 className="title">
        <span className="fan-span">Unlock/</span>
        <span className="creator-span">Deliver</span> Exclusive Access
      </h2>
    ),
    subtitle: (
      <p className="blue-grey-text">
        <span className="fan-span">Complete/</span>
        <span className="creator-span">Create</span> exciting achievements and
        promotions.
      </p>
    ),
    imgSrc: `${REACT_APP_IMAGES_PUBLIC_URL}/LandingImages/Journey/Journey6.webp`,
    magical: true
  }
];
